module.exports = __webpack_public_path__ + "static/media/NotasFiscais3.f2f56a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais3.png
// module id = 2133
// module chunks = 0